<template>
  <div class="mobile_nav_item">
    
    <div class="row">
      <div class="col-3">
        <div class="nav_item_icon"
        @click="goto_path(path_name)"
        >
          <font-awesome-icon :icon="icon"></font-awesome-icon>
        </div>
        
      </div>
      <div class="col-9">
        <div class="nav_item_label">
          <div class="nav_item_label"
          @click="goto_path(path_name)"
          > 
            {{label}}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import router from '@/router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faHome,
  faCheckDouble,
  faClipboardCheck
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faHome,
  faCheckDouble,
  faClipboardCheck
);

export default {
  name: 'nav_mobile_item',
  props: [
    'label',
    'icon',
    'path_name'
  ],
  data () {
    return {
      
    }
  },
  methods: {
    close_mobile_nav: function() {
      this.$root.store.nav.close_mobile_nav();
    },
    goto_path: function(path_name) {
      this.$root.store.goto_path(path_name);

      this.close_mobile_nav();
    }
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.mobile_nav_item {
  font-size: 1.4em;
  padding: 0.5em 0;
  border-bottom: solid 1px #ddd;
  color: $dcom-purple;
  cursor: pointer;

  .nav_item_icon {
    width: 100%;
    text-align: center;
  }

  .nav_item_label {

  }
}

.mobile_nav_item:first-child {
  border-top: solid 1px #ddd;
}
</style>


// WEBPACK FOOTER //
// src/features/navigation/nav_mobile_item.vue